import React, { useEffect, useRef, useCallback } from 'react';
import { ICreditCard, IUser } from 'types';
import styles from './selectCardBenefits.scss';
import Button from 'components/button';
import { scrollToRef } from 'hooks/useScrollOnMount';
import { CreditCardBenefitsImg } from 'constants/explore-cc';
import Slider from 'components/slider';

interface IBenefit {
  name: string;
  description: string;
}

interface IBenefitCardProps {
  benefit: IBenefit;
}

const BenefitCard: React.FC<IBenefitCardProps> = ({ benefit }) => {
  const SvgComponent =
    CreditCardBenefitsImg[benefit.name] || CreditCardBenefitsImg.default;
  return (
    <div className={styles.cardContainer}>
      <div className={styles.cardName}>
        <SvgComponent />
        <span>{benefit.name}</span>
      </div>
      <div className={styles.cardContent}>{benefit.description}</div>
    </div>
  );
};

interface IShowCardBenefits {
  user: IUser;
  providerName: string;
  creditCard: ICreditCard;
  loading: boolean;
  createPolicy: (creditCard: ICreditCard) => void;
}

const ShowCardBenefits: React.FC<IShowCardBenefits> = ({
  creditCard,
  loading,
  createPolicy,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleAdd = useCallback(
    () => createPolicy(creditCard),
    [creditCard, createPolicy],
  );

  const benefits = creditCard.benefits || [];

  useEffect(() => {
    const timeoutId = setTimeout(() => scrollToRef(ref), 100);
    return () => clearTimeout(timeoutId);
  }, [benefits]);

  return (
    <>
      <div className={styles.benefitsWrapper}>
        <div className={styles.creditCardsTitle}>
          Insurance benefits that come with your card
        </div>
        <div className={styles.cardBenefitsContainer}>
          {benefits.map((b) => (
            <BenefitCard key={`benefit_${b.name}`} benefit={b} />
          ))}
        </div>
        <div className={styles.cardBenefitsContainerMobile}>
          <Slider>
            {benefits.map((p) => (
              <BenefitCard key={`benefitM_${p.name}`} benefit={p} />
            ))}
          </Slider>
        </div>
        <div className={styles.btnContainer} ref={ref}>
          <Button
            className={styles.addBtn}
            text="Add card"
            onClick={handleAdd}
            loading={loading}
          />
        </div>
      </div>
    </>
  );
};

export default ShowCardBenefits;
